import { lzSAtomWithLocalStorage } from '@lz-store/services';

const lzSLayoutThemeDirectionAtom = lzSAtomWithLocalStorage<'ltr' | 'rtl'>('layoutThemeDirectionState', 'ltr');

export default lzSLayoutThemeDirectionAtom;
